import { TMap } from '@client/new/helpers/types';
import { Chip } from '@mui/material';
import React from 'react';

const subStyles: TMap<string, any> = {
  Active: {
    backgroundColor: '#5FBC76',
    color: '#fff',
  },
  Cancelled: {
    backgroundColor: '#FFB340',
    color: '#fff',
  },
  BillingFailed: {
    backgroundColor: '#FF7070',
    color: '#fff',
  },
  Inactive: {
    backgroundColor: '#8A8E99',
    color: '#fff',
  },
  None: {
    backgroundColor: '#F5F6FA',
    color: '#151E34',
  },
};

const STATUS_LABELS = {
  Active: 'Active',
  Cancelled: 'Cancelled',
  BillingFailed: 'Billing Failed',
  Inactive: 'Inactive',
  None: 'None',
};

export const SubscriptionStatus = ({
  subscriptionStatus,
}: {
  subscriptionStatus: string;
}) => {
  if (!subscriptionStatus) {
    return null;
  }

  return (
    <span className="flex gap-2 items-center">
      <Chip
        label={STATUS_LABELS[subscriptionStatus] || subscriptionStatus}
        className="rounded-full font-bold"
        style={subStyles[subscriptionStatus]}
      />
    </span>
  );
};
